<div class="migration-page">
  <div class="page-topbar">
    <wm-common-button
      class="back-button"
      [data]="{
        text: 'BACK TO LIST',
        variant: 'basic',
        onClick: backToList.bind(this)
      }"
    ></wm-common-button>
  </div>

  <div class="migration-header">
    <wm-common-text
      class="page-title"
      [data]="{ text: 'Workflow Migration', fontWeight: '500' }"
    ></wm-common-text>
    <wm-common-text
      class="page-subtitle"
      [data]="{
        text:
          'Manage workflow migrations and track workflow migration progress.'
      }"
    ></wm-common-text>
  </div>

  <div *ngIf="successMessage" class="page-banner success">
    <wm-common-text [data]="{ text: successMessage }"></wm-common-text>
  </div>

  <div *ngIf="errorMessage" class="page-banner error">
    <wm-common-text [data]="{ text: errorMessage }"></wm-common-text>
  </div>

  <app-loader *ngIf="loadingPage"></app-loader>

  <div *ngIf="!loadingPage && processing" class="detail-stack">
    <section class="migration-card overview-card">
      <div class="overview-band">
        Workflow Migration:
        {{ processing.sourceSystem || 'Untitled migration' }}
      </div>

      <div class="overview-body">
        <div class="overview-column">
          <dl class="detail-list">
            <div class="detail-row">
              <dt>Source System:</dt>
              <dd>{{ processing.sourceSystem || 'Not set' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Jurisdiction:</dt>
              <dd>{{ processing.jurisdiction || 'Not set' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Created By:</dt>
              <dd>{{ processing.createdBy || 'Unknown' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Created On:</dt>
              <dd>{{ processing.createdOn | date: 'short' }}</dd>
            </div>
          </dl>
        </div>

        <div class="overview-column">
          <dl class="detail-list">
            <div class="detail-row">
              <dt>Current Owner:</dt>
              <dd class="inline-detail">
                <span>{{ processing.currentOwner?.name || 'Unassigned' }}</span>
                <button
                  type="button"
                  class="inline-link-button"
                  (click)="openChangeOwnerDialog()"
                  [disabled]="working"
                >
                  CHANGE
                </button>
              </dd>
            </div>
            <div class="detail-row">
              <dt>Started By:</dt>
              <dd>{{ processing.startedBy || 'Not Started' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Started On:</dt>
              <dd>
                {{
                  processing.startedOn
                    ? (processing.startedOn | date: 'short')
                    : 'Not Started'
                }}
              </dd>
            </div>
            <div class="detail-row">
              <dt>Migrated Workflow By:</dt>
              <dd>{{ processing.workflowMigratedBy || 'Not Migrated' }}</dd>
            </div>
            <div class="detail-row">
              <dt>Migrated Workflow On:</dt>
              <dd>
                {{
                  processing.workflowMigratedOn
                    ? (processing.workflowMigratedOn | date: 'short')
                    : 'Not Migrated'
                }}
              </dd>
            </div>
            <div class="detail-row">
              <dt>Migrated Workflow:</dt>
              <dd>
                <button
                  *ngIf="processing.migratedWorkflowId"
                  type="button"
                  class="inline-link-button"
                  (click)="viewWorkflow()"
                >
                  VIEW WORKFLOW
                </button>
                <span *ngIf="!processing.migratedWorkflowId" class="muted-text">
                  No Workflow
                </span>
              </dd>
            </div>
            <div class="detail-row">
              <dt>Migration JSON:</dt>
              <dd>
                <button
                  *ngIf="processing.metaDataFilePath"
                  type="button"
                  class="inline-link-button"
                  (click)="downloadMetadataFile()"
                  [disabled]="working"
                >
                  DOWNLOAD JSON
                </button>
                <span *ngIf="!processing.metaDataFilePath" class="muted-text">
                  No File
                </span>
              </dd>
            </div>
            <div class="detail-row">
              <dt>Application Data:</dt>
              <dd>
                <span *ngIf="processing.applicationDataFilePath"
                  >File Uploaded</span
                >
                <span
                  *ngIf="!processing.applicationDataFilePath"
                  class="muted-text"
                >
                  No File
                </span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>

    <section
      class="migration-card workflow-settings-card"
      *ngIf="processing.workflowType || processing.expirationFormula"
    >
      <div class="card-header-row compact">
        <h3>Workflow Configuration</h3>
      </div>
      <div class="card-body">
        <div class="workflow-settings-grid">
          <div class="detail-row stacked">
            <dt>Workflow Type:</dt>
            <dd>{{ processing.workflowType || 'Permit (default)' }}</dd>
          </div>

          <div
            class="detail-row stacked"
            *ngIf="
              processing.workflowType === 'Renewable' &&
              processing.expirationFormula
            "
          >
            <dt>Expiration Formula:</dt>
            <dd class="code-copy">{{ processing.expirationFormula }}</dd>
          </div>
        </div>
      </div>
    </section>

    <div class="tab-row">
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'execution'"
        (click)="activeTab = 'execution'"
      >
        <span class="tab-title">Execution Team</span>
        <span class="tab-caption">Run migration steps</span>
      </button>
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'data'"
        (click)="activeTab = 'data'"
      >
        <span class="tab-title">Data Team</span>
        <span class="tab-caption">File uploads &amp; validation</span>
      </button>
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'monitor'"
        (click)="activeTab = 'monitor'"
      >
        <span class="tab-title">Monitor</span>
        <span class="tab-caption">Workflow &amp; application status</span>
      </button>
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'history'"
        (click)="activeTab = 'history'; loadHistory()"
      >
        <span class="tab-title">Migration History</span>
        <span class="tab-caption">Execution audit trail</span>
      </button>
    </div>

    <div *ngIf="activeTab === 'execution'" class="detail-stack">
      <section class="migration-card">
        <div class="card-header-row">
          <h3>Parsed Field Mapping</h3>
          <button
            *ngIf="processing.workflowMigratedOn && showDataEntitiesGrid"
            type="button"
            class="inline-link-button"
            (click)="hideDataEntitiesGrid()"
          >
            HIDE
          </button>
        </div>

        <div class="card-body">
          <div
            *ngIf="processing.workflowMigratedOn && !showDataEntitiesGrid"
            class="empty-editor-state"
          >
            <p class="empty-editor-copy">
              Migration data entities are configured and the workflow has been
              migrated.
            </p>
            <button
              type="button"
              class="primary-action"
              (click)="openDataEntitiesGrid()"
            >
              EDIT DATA ENTITIES
            </button>
          </div>

          <app-migration-processing-data-entities
            *ngIf="!processing.workflowMigratedOn || showDataEntitiesGrid"
            [migrationProcessingId]="processing.id"
            (entitiesChanged)="onDataEntitiesChanged()"
          ></app-migration-processing-data-entities>
        </div>
      </section>

      <section
        class="migration-card step-card success"
        *ngIf="canPerformMigration"
      >
        <div class="step-band success">Step 1: Perform Workflow Migration</div>

        <div class="card-body detail-stack">
          <div *ngIf="processing.workflowMigratedOn" class="info-alert">
            <strong>Workflow Previously Migrated</strong>
            <p>
              Migrated By: {{ processing.workflowMigratedBy || 'Unknown'
              }}<br />
              Migrated On:
              {{ processing.workflowMigratedOn | date: 'short' }}
            </p>
          </div>

          <div *ngIf="isWorkflowMigrationQueued" class="info-alert">
            <strong>Workflow Migration {{ workflowTaskStatus }}</strong>
            <p>
              The migration task has been queued for the Scheduling Engine. See
              the monitoring section below for live status.
            </p>
          </div>

          <div *ngIf="!showMigrationForm" class="detail-stack">
            <p
              *ngIf="
                !processing.workflowMigratedOn && !isWorkflowMigrationQueued
              "
            >
              After reviewing and updating the migration data entities, execute
              the migration.
            </p>
            <p *ngIf="isWorkflowMigrationQueued">
              A workflow migration task is already
              {{ workflowTaskStatus?.toLowerCase() }}. Wait for it to finish
              before starting another migration.
            </p>
            <p *ngIf="processing.workflowMigratedOn">
              You can update the migration data entities and migrate the
              workflow again. This will update the existing workflow.
            </p>

            <div class="inline-actions">
              <button
                type="button"
                class="primary-action success"
                (click)="startMigrationFlow()"
                [disabled]="working || isWorkflowMigrationQueued"
              >
                {{
                  processing.workflowMigratedOn
                    ? 'RE-PROCESS DATA ENTITIES AND MIGRATE AGAIN'
                    : isWorkflowMigrationQueued
                    ? 'WORKFLOW MIGRATION ' + workflowTaskStatus?.toUpperCase()
                    : 'MIGRATE WORKFLOW'
                }}
              </button>
            </div>
          </div>

          <div
            class="nested-panel"
            *ngIf="isWorkflowMigrationQueued || processing.workflowMigratedOn"
          >
            <app-settings-migrate-workflow-monitor
              [processing]="processing"
              (workflowTaskCompleted)="loadProcessing()"
            ></app-settings-migrate-workflow-monitor>
          </div>

          <div *ngIf="showMigrationForm" class="detail-stack">
            <div class="nested-panel detail-stack">
              <h4>Workflow Migration Configuration</h4>

              <div class="field-grid">
                <wm-common-dropdown
                  name="templateWorkflowId"
                  [(ngModel)]="selectedWorkflowId"
                  [data]="templateWorkflowDropdownData"
                ></wm-common-dropdown>

                <wm-common-textfield
                  name="workflowName"
                  [(ngModel)]="workflowName"
                  [data]="{
                    label: 'Workflow Name',
                    placeholder: 'Enter the target workflow name',
                    required: true
                  }"
                ></wm-common-textfield>
              </div>

              <div class="helper-panel" *ngIf="processing.workflowMigratedOn">
                This migration already created a workflow. Running it again will
                update the existing workflow definition.
              </div>

              <div class="inline-actions">
                <button
                  type="button"
                  class="primary-action"
                  (click)="generateSummary()"
                  [disabled]="!canGenerateSummary"
                >
                  GENERATE SUMMARY
                </button>
                <button
                  type="button"
                  class="secondary-action"
                  (click)="resetSummary()"
                  [disabled]="working"
                >
                  RESET
                </button>
                <button
                  type="button"
                  class="secondary-action"
                  (click)="cancelMigrationFlow()"
                  [disabled]="working"
                >
                  CANCEL
                </button>
              </div>
            </div>

            <div class="nested-panel detail-stack" *ngIf="migrationSummary">
              <h4>Migration Summary</h4>

              <div *ngIf="hasErrors()" class="info-alert error">
                <strong>
                  Summary contains errors. Fix the conflicts before executing
                  migration.
                </strong>
                <ul class="summary-list">
                  <li *ngFor="let error of migrationSummary.errorMessages">
                    {{ error }}
                  </li>
                </ul>
              </div>

              <div
                class="activity-summary"
                *ngIf="hierarchicalActivities.length > 0"
              >
                <article
                  class="activity-card"
                  *ngFor="let activity of hierarchicalActivities"
                >
                  <div class="activity-header">
                    <span class="activity-name">{{ activity.name }}</span>
                    <span
                      class="status-pill"
                      [class.success]="activity.action === 'add'"
                    >
                      {{ activity.action === 'add' ? 'Add' : 'Remove' }}
                    </span>
                  </div>
                  <ul
                    class="summary-list"
                    *ngIf="activity.dataEntities.length > 0"
                  >
                    <li *ngFor="let entity of activity.dataEntities">
                      {{ entity.templateCode }} -
                      {{ entity.action === 'add' ? 'add' : 'remove' }}
                    </li>
                  </ul>
                </article>
              </div>

              <div
                class="helper-panel"
                *ngIf="
                  !hasErrors() &&
                  hierarchicalActivities.length === 0 &&
                  !migrationSummary.customLists?.length &&
                  !migrationSummary.roles?.length
                "
              >
                No activity or data-entity changes were detected in the current
                summary.
              </div>

              <div
                class="conflict-card"
                *ngIf="migrationSummary.customLists?.length > 0"
              >
                <div class="conflict-title">Custom Lists</div>
                <div
                  class="conflict-row"
                  *ngFor="let list of migrationSummary.customLists"
                >
                  <label class="conflict-toggle">
                    <input
                      *ngIf="list.alreadyExists"
                      type="checkbox"
                      [checked]="isCustomListSelected(list.name)"
                      (change)="toggleCustomListUpdate(list.name)"
                    />
                    <span>
                      {{ list.name }}
                      <small *ngIf="list.roleName">
                        Role: {{ list.roleName }}
                      </small>
                    </span>
                  </label>
                  <span
                    *ngIf="list.roleName"
                    class="status-pill"
                    [class.success]="list.roleExists"
                    [class.error]="!list.roleExists"
                  >
                    {{ list.roleExists ? 'Role Available' : 'Role Missing' }}
                  </span>
                  <span
                    class="status-pill"
                    [class.warning]="list.alreadyExists"
                  >
                    {{
                      list.alreadyExists
                        ? isCustomListSelected(list.name)
                          ? 'Replace'
                          : 'Skip'
                        : 'Create'
                    }}
                  </span>
                </div>
              </div>

              <div
                class="conflict-card"
                *ngIf="migrationSummary.roles?.length > 0"
              >
                <div class="conflict-title">Roles</div>
                <div
                  class="conflict-row"
                  *ngFor="let role of migrationSummary.roles"
                >
                  <label class="conflict-toggle">
                    <input
                      *ngIf="role.alreadyExists"
                      type="checkbox"
                      [checked]="isRoleSelected(role.name)"
                      (change)="toggleRoleUpdate(role.name)"
                    />
                    <span>{{ role.name }}</span>
                  </label>
                  <span
                    class="status-pill"
                    [class.warning]="role.alreadyExists"
                  >
                    {{
                      role.alreadyExists
                        ? isRoleSelected(role.name)
                          ? 'Replace'
                          : 'Skip'
                        : 'Create'
                    }}
                  </span>
                </div>
              </div>

              <label class="verify-toggle">
                <input
                  type="checkbox"
                  [(ngModel)]="summaryVerified"
                  [disabled]="hasErrors()"
                />
                I reviewed the summary and want to proceed with migration.
              </label>

              <div
                class="helper-panel warning"
                *ngIf="migrationSummary.workflowExists"
              >
                A workflow with this name already exists. Check overwrite if you
                want the existing workflow replaced.
              </div>

              <label
                class="verify-toggle"
                *ngIf="migrationSummary.workflowExists"
              >
                <input type="checkbox" [(ngModel)]="overwriteWorkflow" />
                Overwrite existing workflow
              </label>

              <div class="inline-actions">
                <button
                  type="button"
                  class="primary-action success"
                  (click)="executeMigration()"
                  [disabled]="!canExecuteMigration"
                >
                  EXECUTE MIGRATION
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="migration-card step-card"
        *ngIf="
          processing.workflowMigratedOn && processing.applicationDataFilePath
        "
      >
        <div class="step-band">Step 2: Migrate Application Data</div>

        <div class="card-body detail-stack">
          <p>
            Execute the migration of application data into the workflow. This
            will create workflow applications from the uploaded JSON data.
          </p>

          <div *ngIf="latestApplicationCoordinatorTask" class="info-alert">
            <strong>Application migration coordinator {{ applicationCoordinatorStatus }}</strong>
            <p>
              {{ activeApplicationCoordinatorTasks.length }} coordinator task(s) are currently queued or executing.
              See the Monitor tab for task timing and application progress.
            </p>
          </div>

          <div
            *ngIf="!processing.applicationDataMigratedOn"
            class="detail-stack"
          >
            <p>
              <strong>{{
                applicationDataValidationStatus?.recordCount || 0
              }}</strong>
              application record(s) ready to migrate.
            </p>

            <div
              *ngIf="applicationDataMigrationError"
              class="info-alert error"
              style="margin-bottom: 16px;"
            >
              <strong>Migration Failed</strong>
              <p>{{ applicationDataMigrationError }}</p>
              <button
                type="button"
                class="close-btn"
                (click)="applicationDataMigrationError = ''"
                aria-label="Close"
              >
                ✕
              </button>
            </div>

            <div class="inline-actions">
              <button
                type="button"
                class="primary-action success"
                (click)="requestMigrateApplicationData()"
                [disabled]="
                  working || !applicationDataValidationStatus?.isValid
                "
              >
                EXECUTE APPLICATION DATA MIGRATION
              </button>
            </div>
            <p
              class="muted-copy"
              *ngIf="!applicationDataValidationStatus?.isValid"
            >
              Application data must be validated before migration. Go to the
              Data Team tab to validate it.
            </p>
          </div>

          <div
            *ngIf="processing.applicationDataMigratedOn"
            class="detail-stack"
          >
            <div class="info-alert success">
              <strong>Application data migrated successfully!</strong>
              <p>
                Migrated by:
                {{ processing.applicationDataMigratedBy || 'Unknown' }}<br />
                Migrated on:
                {{ processing.applicationDataMigratedOn | date: 'short' }}
              </p>
            </div>

            <div
              *ngIf="applicationDataMigrationError"
              class="info-alert error"
              style="margin-bottom: 16px;"
            >
              <strong>Re-migration Failed</strong>
              <p>{{ applicationDataMigrationError }}</p>
              <button
                type="button"
                class="close-btn"
                (click)="applicationDataMigrationError = ''"
                aria-label="Close"
              >
                ✕
              </button>
            </div>

            <div class="inline-actions">
              <button
                type="button"
                class="primary-action warning"
                (click)="requestMigrateApplicationData()"
                [disabled]="working"
              >
                RE-EXECUTE APPLICATION DATA MIGRATION
              </button>
            </div>
            <p class="muted-copy">
              Re-executing will update or create applications based on the
              current application data file.
            </p>
          </div>
        </div>
      </section>

      <section class="migration-card step-card" *ngIf="canPerformMigration">
        <div class="step-band muted">Step 3: Mark as Complete</div>

        <div class="card-body detail-stack">
          <p>
            Once the workflow migration has been successfully executed and
            verified, mark this workflow migration as complete.
          </p>

          <div
            class="warning-alert"
            *ngIf="!processing.applicationDataFilePath"
          >
            <strong>Application data is required.</strong> Please ensure
            application data has been uploaded in the Data Team tab before
            marking this migration as complete.
          </div>

          <div
            class="warning-alert"
            *ngIf="
              processing.applicationDataFilePath &&
              !processing.applicationDataMigratedOn
            "
          >
            <strong>Application data migration is required.</strong> Please
            complete Step 1 before marking this migration as complete.
          </div>

          <div class="inline-actions">
            <button
              type="button"
              class="primary-action"
              (click)="openCompleteModal()"
              [disabled]="!canMarkComplete"
            >
              MARK AS COMPLETE
            </button>
            <button
              type="button"
              class="danger-link-button"
              (click)="openDeleteModal()"
              [disabled]="working"
            >
              DELETE
            </button>
          </div>

          <p class="muted-copy">
            Marking as complete will remove the workflow migration from the
            ready-to-start list. Deleting will hide the record.
          </p>
        </div>
      </section>
    </div>

    <div *ngIf="activeTab === 'monitor'" class="detail-stack">
      <section class="migration-card">
        <div class="card-body">
          <app-settings-migrate-workflow-monitor
            [processing]="processing"
            (workflowTaskCompleted)="loadProcessing()"
          ></app-settings-migrate-workflow-monitor>
        </div>
      </section>
    </div>

    <div *ngIf="activeTab === 'data'" class="detail-stack">
      <section class="migration-card">
        <div class="card-header-row">
          <h3>Re-Upload Migration Files</h3>
        </div>

        <div class="card-body detail-stack">
          <p>
            You can update the metadata JSON file if needed before performing
            the migration.
          </p>

          <div class="upload-block">
            <label class="block-label">Metadata JSON File</label>
            <wm-upload
              buttonText="Re-Upload Metadata File"
              validDocumentTypes="json"
              [pathSegments]="[
                'migration-processing',
                processing.id,
                'metadata'
              ]"
              (fileUploaded)="onMetadataFileUploaded($event)"
              (fileDeleted)="onMetadataFileDeleted()"
              [key]="'metadata-' + processing.id"
              [allowMultipleFiles]="false"
              category="MigrationProcessing"
              [deleteStoredDocument]="false"
              [showUploadedFilesList]="true"
            ></wm-upload>
            <div
              *ngIf="reprocessingMetadata"
              class="page-banner"
              role="status"
              aria-live="polite"
            >
              <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
              Re-processing entity data from the metadata file...
            </div>
            <div
              *ngIf="metadataValidationErrors.length > 0"
              class="page-banner error"
              role="alert"
            >
              <strong>Metadata validation failed</strong>
              <ul>
                <li *ngFor="let error of metadataValidationErrors">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div *ngIf="processing.metaDataFilePath" class="file-actions">
              <button
                type="button"
                class="download-link-button"
                (click)="downloadMetadataFile()"
                [disabled]="working"
              >
                Download Current Metadata File
              </button>
            </div>
            <p class="muted-copy">
              Upload a new metadata JSON file to replace the current metadata
              configuration.
            </p>
          </div>
        </div>
      </section>

      <section class="migration-card">
        <div class="card-header-row">
          <h3>Upload Application Data</h3>
        </div>

        <div class="card-body detail-stack">
          <p>
            Upload a JSON file containing application data for the migrated
            workflow. The data will be validated against the workflow's data
            entities.
            <strong class="warning-copy">
              This is required before the migration can be marked as complete.
            </strong>
          </p>

          <div class="upload-block">
            <label class="block-label">
              Application Data JSON File <span class="required-mark">*</span>
            </label>
            <wm-upload
              buttonText="Select JSON File"
              validDocumentTypes="json"
              [pathSegments]="[
                'migration-processing',
                processing.id,
                'application-data'
              ]"
              (fileUploaded)="onApplicationDataUploaded($event)"
              (fileDeleted)="onApplicationDataDeleted()"
              [key]="'app-data-' + processing.id"
              [allowMultipleFiles]="false"
              category="MigrationApplicationData"
              [deleteStoredDocument]="false"
              [showUploadedFilesList]="true"
            ></wm-upload>
            <div
              *ngIf="processing.applicationDataFilePath"
              class="file-actions"
            >
              <button
                type="button"
                class="download-link-button"
                (click)="downloadApplicationDataFile()"
                [disabled]="working"
              >
                Download Current Application Data File
              </button>
            </div>
            <p class="muted-copy">
              Upload a JSON file with an array of application objects. Each
              object should have properties matching the workflow's data entity
              template codes.
            </p>
            <div class="download-row">
              <a
                href="assets/sample-application-data-comprehensive.json"
                download="sample-application-data-comprehensive.json"
                target="_blank"
              >
                Download Sample Application Data File
              </a>
              <span>Example application data with multiple applications</span>
            </div>
          </div>

          <div
            *ngIf="
              processing.applicationDataFilePath &&
              !applicationDataValidationStatus
            "
            class="detail-stack"
          >
            <div class="inline-actions">
              <button
                type="button"
                class="primary-action"
                (click)="validateExistingApplicationData()"
                [disabled]="working"
              >
                VALIDATE EXISTING APPLICATION DATA
              </button>
            </div>
            <p class="muted-copy">
              Application data file already uploaded. Click to validate against
              the workflow.
            </p>
          </div>

          <div *ngIf="applicationDataValidationStatus" class="validation-card">
            <div
              *ngIf="applicationDataValidationStatus.isValidating"
              class="info-alert"
            >
              <strong>Validating...</strong>
            </div>

            <div
              *ngIf="
                !applicationDataValidationStatus.isValidating &&
                applicationDataValidationStatus.isValid
              "
              class="info-alert success"
            >
              <strong>Validation Passed!</strong>
              <p>
                {{ applicationDataValidationStatus.recordCount }} record(s)
                found with valid properties matching the workflow data entities.
              </p>
            </div>

            <div
              *ngIf="
                !applicationDataValidationStatus.isValidating &&
                !applicationDataValidationStatus.isValid
              "
              class="info-alert error"
            >
              <strong>Validation Failed</strong>
              <ul class="summary-list">
                <li
                  *ngFor="let error of applicationDataValidationStatus.errors"
                >
                  {{ error }}
                </li>
              </ul>
            </div>

            <button
              *ngIf="!applicationDataValidationStatus.isValidating"
              type="button"
              class="inline-link-button"
              (click)="showValidationDetails = !showValidationDetails"
            >
              {{
                showValidationDetails
                  ? 'HIDE VALIDATION DETAILS'
                  : 'SHOW VALIDATION DETAILS'
              }}
            </button>

            <div
              *ngIf="
                showValidationDetails &&
                !applicationDataValidationStatus.isValidating
              "
              class="validation-details"
            >
              <div>
                <div class="detail-label">
                  Matched Properties ({{
                    applicationDataValidationStatus.matchedProperties.length
                  }})
                </div>
                <div class="chip-list">
                  <span
                    *ngFor="
                      let prop of applicationDataValidationStatus.matchedProperties
                    "
                    class="chip success"
                  >
                    {{ prop }}
                  </span>
                </div>
              </div>

              <div>
                <div class="detail-label">
                  Unmatched Properties ({{
                    applicationDataValidationStatus.unmatchedProperties.length
                  }})
                </div>
                <div class="chip-list">
                  <span
                    *ngFor="
                      let prop of applicationDataValidationStatus.unmatchedProperties
                    "
                    class="chip warning"
                  >
                    {{ prop }}
                  </span>
                </div>
              </div>

              <div>
                <div class="detail-label">
                  Missing Required Properties ({{
                    applicationDataValidationStatus.missingRequiredProperties
                      .length
                  }})
                </div>
                <div class="chip-list">
                  <span
                    *ngFor="
                      let prop of applicationDataValidationStatus.missingRequiredProperties
                    "
                    class="chip error"
                  >
                    {{ prop }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="migration-card">
        <div class="card-header-row">
          <h3>Migration Notes</h3>
        </div>

        <div class="card-body detail-stack">
          <wm-common-textfield
            name="newNote"
            [(ngModel)]="newNote"
            [data]="{
              label: 'Add Note',
              type: 'text-area',
              textAreaRows: 4,
              placeholder: 'Capture status, decisions, blockers, or next steps.'
            }"
          ></wm-common-textfield>

          <div class="inline-actions">
            <button
              type="button"
              class="primary-action"
              (click)="addNote()"
              [disabled]="!newNote.trim() || working"
            >
              ADD NOTE
            </button>
          </div>

          <div
            class="empty-state"
            *ngIf="!processing.migrationProcessingNotes?.length"
          >
            No notes have been added yet.
          </div>

          <div
            class="notes-list"
            *ngIf="processing.migrationProcessingNotes?.length"
          >
            <article
              class="note-card"
              *ngFor="let note of processing.migrationProcessingNotes"
            >
              <div class="note-meta">
                <strong>{{ note.createdBy || 'Unknown user' }}</strong>
                <span>{{ note.createdOn | date: 'short' }}</span>
              </div>
              <p>{{ note.note }}</p>
            </article>
          </div>
        </div>
      </section>
    </div>

    <div *ngIf="activeTab === 'history'" class="detail-stack">
      <section class="migration-card">
        <div class="card-header-row">
          <h3>Migration Execution History</h3>
          <button
            type="button"
            class="inline-link-button"
            (click)="loadHistory()"
            [disabled]="loadingHistory"
          >
            {{ loadingHistory ? 'LOADING...' : 'REFRESH' }}
          </button>
        </div>

        <div class="card-body">
          <div *ngIf="loadingHistory" class="empty-state">
            Loading history&hellip;
          </div>

          <div
            *ngIf="
              !loadingHistory &&
              migrationExecutions.length === 0 &&
              migrationApplicationHistories.length === 0
            "
            class="empty-state"
          >
            No migration history recorded yet.
          </div>

          <table
            *ngIf="!loadingHistory && migrationExecutions.length > 0"
            class="data-table"
          >
            <colgroup>
              <col style="width: 2.5rem;" />
              <col style="width: 10rem;" />
              <col />
              <col style="width: 9rem;" />
              <col style="width: 9rem;" />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Executed On</th>
                <th>Executed By</th>
                <th>Result</th>
                <th>JSON</th>
                <th>Errors</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let exec of migrationExecutions; let i = index">
                <td class="muted-copy">{{ migrationExecutions.length - i }}</td>
                <td>{{ exec.executedOn | date: 'M/d/yy, h:mm a' }}</td>
                <td>{{ exec.executedBy || '—' }}</td>
                <td>
                  <button
                    *ngIf="exec.resultWorkflowId"
                    type="button"
                    class="inline-link-button"
                    (click)="openExecutionWorkflow(exec.resultWorkflowId)"
                    title="Open the workflow created in this run"
                  >
                    OPEN WORKFLOW
                  </button>
                  <span *ngIf="!exec.resultWorkflowId" class="muted-copy"
                    >—</span
                  >
                </td>
                <td>
                  <button
                    *ngIf="exec.csvDataFilePath"
                    type="button"
                    class="inline-link-button"
                    (click)="
                      downloadExecutionMetadataFile(exec.csvDataFilePath)
                    "
                    title="Download the JSON file used for this run"
                  >
                    DOWNLOAD JSON
                  </button>
                  <span *ngIf="!exec.csvDataFilePath" class="muted-copy"
                    >—</span
                  >
                </td>
                <td>
                  <span
                    *ngIf="exec.executionErrors"
                    class="chip error"
                    [title]="exec.executionErrors"
                  >
                    {{ exec.executionErrors | slice: 0:60
                    }}{{ exec.executionErrors.length > 60 ? '…' : '' }}
                  </span>
                  <span *ngIf="!exec.executionErrors" class="chip success"
                    >None</span
                  >
                </td>
              </tr>
            </tbody>
          </table>

          <p
            *ngIf="!loadingHistory && migrationExecutions.length > 0"
            class="muted-copy"
            style="margin-top: 0.75rem;"
          >
            {{ migrationExecutions.length }} run{{
              migrationExecutions.length !== 1 ? 's' : ''
            }}
            recorded &mdash; newest first
          </p>

          <div class="card-header-row" style="margin-top: 1.5rem;">
            <h3>Application Data Migration History</h3>
          </div>

          <div
            *ngIf="
              !loadingHistory && migrationApplicationHistories.length === 0
            "
            class="empty-state"
          >
            No applications have been tracked for this migration yet.
          </div>

          <table
            *ngIf="!loadingHistory && migrationApplicationHistories.length > 0"
            class="data-table"
          >
            <colgroup>
              <col style="width: 2.5rem;" />
              <col />
              <col style="width: 10rem;" />
              <col style="width: 12rem;" />
              <col style="width: 9rem;" />
              <col style="width: 9rem;" />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Application Identifier</th>
                <th>Application</th>
                <th>Migrated On</th>
                <th>Migrated By</th>
                <th>Migration File</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let history of migrationApplicationHistories;
                  let i = index
                "
              >
                <td class="muted-copy">
                  {{ migrationApplicationHistories.length - i }}
                </td>
                <td>{{ history.applicationIdentifier || '—' }}</td>
                <td>
                  <button
                    *ngIf="history.workflowApplicationId"
                    type="button"
                    class="inline-link-button"
                    (click)="
                      openMigratedApplication(history.workflowApplicationId)
                    "
                    title="Open migrated application"
                  >
                    OPEN APPLICATION
                  </button>
                  <span
                    *ngIf="!history.workflowApplicationId"
                    class="muted-copy"
                    >—</span
                  >
                </td>
                <td>{{ history.migratedOn | date: 'M/d/yy, h:mm a' }}</td>
                <td>{{ history.migratedBy || '—' }}</td>
                <td>
                  <button
                    *ngIf="history.applicationDataFilePath"
                    type="button"
                    class="inline-link-button"
                    (click)="
                      downloadExecutionMetadataFile(
                        history.applicationDataFilePath
                      )
                    "
                    title="Download the application data file used in this migration run"
                  >
                    DOWNLOAD FILE
                  </button>
                  <span
                    *ngIf="!history.applicationDataFilePath"
                    class="muted-copy"
                    >—</span
                  >
                </td>
              </tr>
            </tbody>
          </table>

          <p
            *ngIf="!loadingHistory && migrationApplicationHistories.length > 0"
            class="muted-copy"
            style="margin-top: 0.75rem;"
          >
            {{ migrationApplicationHistories.length }} application record{{
              migrationApplicationHistories.length !== 1 ? 's' : ''
            }}
            tracked &mdash; newest first
          </p>
        </div>
      </section>
    </div>
  </div>
</div>

<div class="modal-scrim" *ngIf="showChangeOwnerDialog">
  <div class="modal-card">
    <div class="modal-header">
      <h3>Change Owner</h3>
      <button
        type="button"
        class="close-modal-button"
        (click)="cancelChangeOwnerDialog()"
      >
        ×
      </button>
    </div>

    <div class="modal-body detail-stack">
      <p>Select a new owner for this workflow migration.</p>

      <wm-common-dropdown
        name="ownerId"
        [(ngModel)]="newOwnerId"
        [data]="ownerDropdownData"
      ></wm-common-dropdown>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="secondary-action"
        (click)="cancelChangeOwnerDialog()"
      >
        CANCEL
      </button>
      <button
        type="button"
        class="primary-action"
        (click)="saveOwner()"
        [disabled]="working"
      >
        CHANGE OWNER
      </button>
    </div>
  </div>
</div>

<wm-common-confirmation-modal
  [data]="completeConfirmModal"
  (onYesClick)="markAsComplete()"
  (onNoClick)="completeConfirmModal.open = false"
></wm-common-confirmation-modal>

<wm-common-confirmation-modal
  [data]="deleteConfirmModal"
  (onYesClick)="deleteMigrationProcessing()"
  (onNoClick)="deleteConfirmModal.open = false"
></wm-common-confirmation-modal>

<wm-common-confirmation-modal
  [data]="queueAnotherApplicationMigrationConfirmModal"
  (onYesClick)="confirmQueueAnotherApplicationMigration()"
  (onNoClick)="queueAnotherApplicationMigrationConfirmModal.open = false"
>
  <div class="coordinator-confirmation-tasks">
    <div
      class="coordinator-confirmation-task"
      *ngFor="let task of activeApplicationCoordinatorTasks; let index = index"
    >
      <strong>Coordinator {{ index + 1 }}</strong>
      <dl>
        <div>
          <dt>Queued On</dt>
          <dd>{{ task.queuedOn ? (task.queuedOn | date: 'short') : 'Unknown' }}</dd>
        </div>
        <div>
          <dt>Executed On</dt>
          <dd>{{ task.executedOn ? (task.executedOn | date: 'short') : 'Not started' }}</dd>
        </div>
      </dl>
    </div>
  </div>
</wm-common-confirmation-modal>
